import { logEvent } from "firebase/analytics"
import { useRef } from "react";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent"

export default function DashboardSideNav(
    {
        isLoading,
        selectedMapId,
        userMaps,
        userProfile,
        analytics,
        onSignOutClick,
        onMapSelected,
        onAddMapClick
    }
) {

    const sideNavOverlayRef = useRef(null);

    return (
        <div className="drawer-side z-20 md:w-[20%] md:min-w-[20%] md:max-w-[20%]">
            <label ref={sideNavOverlayRef} htmlFor="my-drawer-3" aria-label="close sidebar" className="drawer-overlay"></label>

            <div className={`block w-max md:w-full max-w-[70%] md:max-w-full h-full no-scrollbar`}>
                <ul className="menu bg-base-300 min-h-full w-full p-4 gap-2">
                    <li className="flex flex-col items-center pb-2">
                        <img 
                        className="h-12 w-auto p-0" 
                        src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png" />
                    </li>

                    <button className="btn btn-primary items-center normal-case text-base" onClick={() => { onAddMapClick() }}>
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="fill-primary-content" fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9L11.25 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z"/>
                    </svg>
                    New Map
                    </button>
                    {
                        isLoading && <li>
                            <div className='w-full flex flex-row items-center justify-center gap-2'>
                                <div className="loading loading-infinity loading-md"></div>
                                <div className='font-normal text-base-content'>Loading ...</div>
                            </div>
                        </li>
                    }
                    {
                        !isLoading && userMaps.length == 0 && <li>
                            <div className='w-full flex flex-row items-center justify-center gap-2'>
                                <div className='font-normal text-base-content'>🤷🏻‍♀️ No maps found</div>
                            </div>
                        </li>
                    }
                    {
                        userMaps.map((userMap) => {
                            return (
                                <li key={userMap.id} onClick={() => {
                                    sideNavOverlayRef.current?.click()
                                    onMapSelected(userMap)
                                }}>
                                    <div className={`${selectedMapId == userMap.id ? "bg-base-300" : ""}`}>
                                    <div className={`line-clamp-1`}>
                                        <span className={`text-base ${selectedMapId == userMap.id ? "font-bold" : ""}`}>{userMap.name}</span>
                                    </div>
                                    </div>
                                </li>
                            )
                        })
                    }
                    <li className="flex-1 bg-transparent"></li>
                    {
                        userProfile && <li>
                        <div className="flex flex-row items-center justify-center">
                            <div className="dropdown dropdown-top">
                                <div tabIndex="0" role="button" className="btn btn-ghost btn-circle avatar">
                                    <div className="w-10 rounded-full border-4 border-primary flex">
                                    { userProfile.profilePicture && <img src={  userProfile.profilePicture } /> }
                                    { !userProfile.profilePicture && <span className="text-lg self-center w-full">{ userProfile.name[0] }</span> }
                                    </div>
                                    
                                    {/* <div className="avatar placeholder w-10 h-10">
                                    <div className="bg-neutral text-neutral-content rounded-full w-10 h-10">
                                        <span className="text-xl">AI</span>
                                    </div>
                                    </div> */}
                                </div>
                                <ul tabIndex="0" className="menu menu-sm dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52 fixed z-50">
                                    {/* <li onClick={() => {
                                        console.log(`view own profile click ${analytics}`)
                                        logEvent(analytics, AnalyticsEvent.VIEW_OWN_PROFILE_CLICK, {})
                                        window.location.href = "/profile"
                                    }}>
                                    <div className="py-4">
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_429_11217)">
                                            <path className="stroke-base-content" d="M4 18C4 15.7908 5.79086 14 8 14H16C18.2091 14 20 15.7908 20 18V18C20 19.1045 19.1046 20 18 20H6C4.89543 20 4 19.1045 4 18V18Z" strokeWidth="2.5" strokeLinejoin="round"/>
                                            <circle cx="12" cy="6.99997" r="3" strokeWidth="2.5" className="stroke-base-content"/>
                                            </g>
                                        </svg>
                                        <span className="text-base">View Profile</span>
                                        </div>
                                    </li> */}
                                    <li>
                                        <div className="py-4" onClick={() => { 
                                            logEvent(analytics, AnalyticsEvent.LOGOUT_CLICK, {})
                                            onSignOutClick()
                                        }}>
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className="fill-base-content" d="M12.9999 2C10.2385 2 7.99991 4.23858 7.99991 7C7.99991 7.55228 8.44762 8 8.99991 8C9.55219 8 9.99991 7.55228 9.99991 7C9.99991 5.34315 11.3431 4 12.9999 4H16.9999C18.6568 4 19.9999 5.34315 19.9999 7V17C19.9999 18.6569 18.6568 20 16.9999 20H12.9999C11.3431 20 9.99991 18.6569 9.99991 17C9.99991 16.4477 9.55219 16 8.99991 16C8.44762 16 7.99991 16.4477 7.99991 17C7.99991 19.7614 10.2385 22 12.9999 22H16.9999C19.7613 22 21.9999 19.7614 21.9999 17V7C21.9999 4.23858 19.7613 2 16.9999 2H12.9999Z"/>
                                        <path className="fill-base-content" d="M13.9999 11C14.5522 11 14.9999 11.4477 14.9999 12C14.9999 12.5523 14.5522 13 13.9999 13V11Z"/>
                                        <path className="fill-base-content" d="M5.71783 11C5.80685 10.8902 5.89214 10.7837 5.97282 10.682C6.21831 10.3723 6.42615 10.1004 6.57291 9.90549C6.64636 9.80795 6.70468 9.72946 6.74495 9.67492L6.79152 9.61162L6.804 9.59454L6.80842 9.58848C6.80846 9.58842 6.80892 9.58778 5.99991 9L6.80842 9.58848C7.13304 9.14167 7.0345 8.51561 6.58769 8.19098C6.14091 7.86637 5.51558 7.9654 5.19094 8.41215L5.18812 8.41602L5.17788 8.43002L5.13612 8.48679C5.09918 8.53682 5.04456 8.61033 4.97516 8.7025C4.83623 8.88702 4.63874 9.14542 4.40567 9.43937C3.93443 10.0337 3.33759 10.7481 2.7928 11.2929L2.08569 12L2.7928 12.7071C3.33759 13.2519 3.93443 13.9663 4.40567 14.5606C4.63874 14.8546 4.83623 15.113 4.97516 15.2975C5.04456 15.3897 5.09918 15.4632 5.13612 15.5132L5.17788 15.57L5.18812 15.584L5.19045 15.5872C5.51509 16.0339 6.14091 16.1336 6.58769 15.809C7.0345 15.4844 7.13355 14.859 6.80892 14.4122L5.99991 15C6.80892 14.4122 6.80897 14.4123 6.80892 14.4122L6.804 14.4055L6.79152 14.3884L6.74495 14.3251C6.70468 14.2705 6.64636 14.1921 6.57291 14.0945C6.42615 13.8996 6.21831 13.6277 5.97282 13.318C5.89214 13.2163 5.80685 13.1098 5.71783 13H13.9999V11H5.71783Z"/>
                                        </svg>
                                        <span className="text-base">Logout</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    }
                </ul>
            </div>
            </div>
        )
}

export const SideNavItem = {
    EXPLORE: "Explore",
    SEARCH: "Search",
    COLLECTION: "Collections"
}